import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useContext } from 'react';
import { Box, IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { LinearProgressWithLabel } from 'console/device-settings/z3k/components/material-utils/linear-progress-with-label';
import { cancelFiletransfers } from 'console/redux/devices/items/actions';
import { firmware_types_titles } from 'console/utils/filetransfers-table';
import { selectDevice } from 'entities/device/lib';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { Z3KSettings } from 'console/device-settings/z3k/provider/types';
export const FileTransfersList = () => {
    const { device_id } = useContext(Z3KSettings);
    const filetransfers = usePartialAppSelector(selectDevice, device_id)?.filetransfers;
    const onCancelFiletransfers = useAction(cancelFiletransfers);
    function onClickCancel(id) {
        return (e) => {
            e.preventDefault();
            if (device_id != null)
                onCancelFiletransfers(device_id, { id });
        };
    }
    return filetransfers != null && filetransfers.length > 0 ? (_jsx(Table, { children: _jsx(TableBody, { children: filetransfers
                .filter((transfer) => !transfer.done)
                .map((transfer) => {
                const title = firmware_types_titles[transfer.type] ??
                    firmware_types_titles[''];
                const percent = ~~(transfer.progress * 100);
                return (_jsx(TableRow, { children: _jsxs(TableCell, { size: "small", padding: "none", variant: "body", children: [title, _jsx(LinearProgressWithLabel, { value: percent, children: _jsx(Box, { mr: 1, children: _jsx(IconButton, { onClick: onClickCancel(transfer.id), size: "small", children: _jsx(Cancel, {}) }) }) })] }) }, transfer.id));
            }) }) })) : null;
};
